/*🤫*/
import * as o_util from "@otto-ec/global-utils";

/*🤫
🤫
🤫
🤫*/
export interface GlobalUtils {
  /*🤫
🤫
🤫*/
  ajax: typeof o_util.ajax;
  animation: typeof o_util.animation;
  connection: typeof o_util.connection;
  browser: typeof o_util.browser;
  cookie: typeof o_util.cookie;
  core: typeof o_util.core;
  dom: typeof o_util.dom;
  event: typeof o_util.event;
  fragment: typeof o_util.fragment;
  hardcore: typeof o_util.hardcore;
  history: typeof o_util.history;
  misc: typeof o_util.misc;
  toggle: typeof o_util.toggle;
}

window.o_util = window.o_util || o_util;
window.o_global = window.o_global || {};
window.o_global.helper = window.o_global.helper || {};

/*🤫*/
window.o_global.helper.bind = o_util.core.bind;
window.o_global.helper.clone = o_util.core.clone;
window.o_global.helper.convertStringToFunction = o_util.core.convertStringToFunction;
window.o_global.helper.extend = o_util.core.extend;
window.o_global.helper.removeFromArray = o_util.core.removeFromArray;
window.o_global.helper.isPlainObject = o_util.core.isPlainObject;
window.o_global.helper.isEmptyObject = o_util.core.isEmptyObject;
window.o_global.helper.cloneFunction = (o_util.core as any).cloneFunction;

/*🤫*/
window.o_global.helper.cookieExist = o_util.cookie.exists;
window.o_global.helper.getCookie = o_util.cookie.get;
window.o_global.helper.getCookieValue = o_util.cookie.get;
window.o_global.helper.removeCookie = o_util.cookie.remove;
window.o_global.helper.setCookie = o_util.cookie.set;

/*🤫*/
window.o_global.helper.delegate = o_util.event.delegate;
window.o_global.helper.stopEvent = o_util.event.stop;
window.o_global.helper.whichTransitionEvent = o_util.event.whichTransitionEndEvent;
window.o_global.helper.addEvent = (o_util.event as any).add;
window.o_global.helper.getEventTarget = (o_util.event as any).getTarget;
window.o_global.helper.preventDefault = (o_util.event as any).preventDefault;
window.o_global.helper.removeEvent = (o_util.event as any).remove;
window.o_global.helper.stopPropagation = (o_util.event as any).stopPropagation;

/*🤫*/
window.o_global.helper.hasClassInParents = o_util.dom.hasClassInParents;
window.o_global.helper.getParentByClassName = o_util.dom.getParentByClassName;
window.o_global.helper.stringToDocumentFragment = o_util.dom.stringToDocumentFragment;
window.o_global.helper.hasClass = (o_util.dom as any).hasClass;
window.o_global.helper.removeClass = (o_util.dom as any).removeClass;
window.o_global.helper.toggleClass = (o_util.dom as any).toggleClass;
window.o_global.helper.getElementsByClassname = (o_util.dom as any).getElementsByClassname;
window.o_global.helper.addClass = (o_util.dom as any).addClass;

/*🤫*/
window.o_global.helper.Easings = o_util.animation.easings;
window.o_global.helper.requestAnimFrame = o_util.animation.requestAnimFrame;
window.o_global.helper._getNewScrollPosition = o_util.legacy.getNewScrollPosition;
window.o_global.helper.scrollTo = o_util.animation.scrollTo;

/*🤫*/
window.o_global.helper.ajax = o_util.legacy.ajaxLegacy;

/*🤫*/
window.o_global.helper.getScrollbarWidth = o_util.browser.getScrollbarWidth;
window.o_global.helper.getStyle = o_util.browser.getStyle;
window.o_global.helper.isIE8 = o_util.browser.isIE8;

/*🤫*/
window.o_global.helper.setScrollRestoration = o_util.history.setScrollRestoration;
window.o_global.helper.resetScrollRestoration = o_util.history.resetScrollRestoration;

/*🤫*/
window.o_global.helper.isResponsive = o_util.misc.isResponsive;
window.o_global.helper.isValidMouseButton = o_util.misc.isValidMouseButton;
window.o_global.helper.setVendorStyle = o_util.misc.setVendorStyle;

/*🤫*/
window.o_global.helper.evalScript = o_util.hardcore.evalScript;
window.o_global.helper.executeInlineScripts = o_util.hardcore.executeInlineScripts;

/*🤫*/
/*🤫*/
window.o_global.referrer = document.referrer;

/*🤫*/
window.o_global.getCookieValue = window.o_global.helper.getCookieValue;
window.o_global.convertStringToFunction = window.o_global.helper.convertStringToFunction;
window.o_global.isResponsive = window.o_global.helper.isResponsive;
